export const CRAWL_DEFAULT_MAX_DEPTH = 3;
export const CRAWL_DEFAULT_MAX_PAGES = 500;
export const CRAWL_MIN_MAX_DEPTH = 1;
export const CRAWL_MAX_MAX_DEPTH = 10;
export const CRAWL_MIN_MAX_PAGES = 1;
export const CRAWL_MAX_MAX_PAGES = 50000;
export const CRAWL_DEFAULT_USE_START_URL_AS_PREFIX_FILTER = true;
export const CRAWL_DEFAULT_ALLOW_SUBDOMAINS = false;

function clampInt(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

/** Digits-only input clamped to [min, max]. Empty stays empty while editing. */
export function sanitizeCrawlLimitInput(
  value: string,
  min: number,
  max: number,
): string {
  const digits = value.replace(/\D/g, '');
  if (digits === '') {
    return '';
  }
  const parsed = Number(digits);
  if (!Number.isFinite(parsed)) {
    return '';
  }
  return String(clampInt(parsed, min, max));
}

export function resolveCrawlLimitValue(
  value: string,
  min: number,
  max: number,
  fallback: number,
): number {
  const trimmed = value.trim();
  if (trimmed === '') {
    return clampInt(fallback, min, max);
  }
  const parsed = Number(trimmed);
  if (!Number.isFinite(parsed)) {
    return clampInt(fallback, min, max);
  }
  return clampInt(parsed, min, max);
}
